import React, { useEffect, useRef } from "react";
import { withScriptjs, withGoogleMap } from "react-google-maps";
import { connect, useSelector } from "react-redux";
import { compose, withProps } from "recompose";
//Styles
import { FullHeightEl, ContainerElement } from "./styles/MapStyles";
//Components
import Map from "./Map";
import { GoogleMap } from "react-google-maps";
//Store
import { mapApiActions } from "../../store/actions/map/mapActions";
import { mapSelectors } from "../../store/selectors";
import { RootState } from "../..";

//Types
import MapApiActions from "../../types/MapApiActions";
import Partner from "../../types/Partner";

interface MapContainerStoreProps {
  partners: Partner[];
}

type MapContainerProps = MapContainerStoreProps & MapApiActions;

const MapContainer: React.FunctionComponent<MapContainerProps> = props => {
  const { fetchAllPartners, partners } = props;
  const queryResults = useSelector(mapSelectors.getQueryResults);
  const bounds: google.maps.LatLngBounds = useSelector(mapSelectors.getBounds);

  let mapRef = useRef<GoogleMap>(null);

  useEffect(() => {
    fetchAllPartners();
  }, []);

  useEffect(() => {
    if (mapRef && mapRef.current && bounds) {
      mapRef.current.fitBounds(bounds);
    }
  }, [bounds]);

  return (
    <Map
      bounds={bounds}
      partners={queryResults ? queryResults : partners}
      forwardedRef={mapRef}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  partners: mapSelectors.getPartners(state)
});

export default compose(
  withProps({
    googleMapURL: process.env.GOOGLE_MAP_URL,
    loadingElement: <FullHeightEl />,
    containerElement: <ContainerElement />,
    mapElement: <FullHeightEl />
  }),
  withScriptjs,
  withGoogleMap,
  connect<MapContainerStoreProps, MapApiActions>(mapStateToProps, mapApiActions)
)(MapContainer);
